import { useMemo } from 'react';
import { type NavGroup, navGroups } from '@/shared/config';
import { canAccess, isAnalyticsOnly, isAnalyticsPath } from './access';
import { useSessionUser } from './session-store';

/** Navigation filtered by the signed-in user's role and permissions. */
export function useVisibleNav(): NavGroup[] {
  const user = useSessionUser();

  return useMemo(() => {
    const analyticsOnly = isAnalyticsOnly(user);
    return navGroups
      .map((g) => ({
        ...g,
        items: g.items.filter(
          (i) => canAccess(user, i.access) && (!analyticsOnly || isAnalyticsPath(i.path)),
        ),
      }))
      .filter((g) => g.items.length > 0);
  }, [user]);
}
